import React, { useState } from 'react';
import Swal from 'sweetalert2';

import TextInputName from './TextInputName';
import TextInputEmail from './TextInputEmail';
import TextInputPhoneNumber from './TextInputPhoneNumber';
import TextInputMessage from './TextInputMessage';
import ButtonSubmit from './ButtonSubmit';

const FormMessage = () => {    
  // State untuk menyimpan nilai dari setiap input
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  // Handler untuk mengupdate state saat input berubah
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Menggunakan data dari state
    const { name, email, phone, message } = formData;

    // Validasi
    if (!name || !email || !phone || !message) {
      Swal.fire({
        title: 'Error!',
        text: 'Semua field harus diisi',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#9333ea'
      });
      return;
    }

    // Create email content
    const subject = `Pesan dari ${name} - Website Contact Form`;
    const body = `
    Nama: ${name}
    Email: ${email}
    Telepon: ${phone}

    Pesan:
    ${message}
    `;

    // Create Gmail compose URL
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=papakilobarbershop@gmail.com&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    try {
      // Show loading
      await Swal.fire({
        title: 'Mohon tunggu...',
        text: 'Sedang membuka Gmail...',
        icon: 'info',
        showConfirmButton: false,
        timer: 1500
      });

      // Open Gmail in new tab
      window.open(gmailUrl, '_blank');

      // Show success message
      await Swal.fire({
        title: 'Berhasil!',
        text: 'Gmail telah dibuka di tab baru. Silakan periksa dan kirim email Anda.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#9333ea'
      });

      // Reset form state
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      
    } catch (error) {
      // Show error message
      Swal.fire({
        title: 'Error!',
        text: 'Terjadi kesalahan saat membuka Gmail. Silakan coba lagi.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#9333ea'
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <TextInputName 
        value={formData.name}
        onChange={handleChange}
      />
      <TextInputEmail 
        value={formData.email}
        onChange={handleChange}
      />
      <TextInputPhoneNumber 
        value={formData.phone}
        onChange={handleChange}
      />
      <TextInputMessage 
        value={formData.message}
        onChange={handleChange}
      />
      <ButtonSubmit />
    </form>
  );
}

export default FormMessage;